import { render, staticRenderFns } from "./ClaimEditor.vue?vue&type=template&id=607c334e&scoped=true&"
import script from "./ClaimEditor.vue?vue&type=script&lang=js&"
export * from "./ClaimEditor.vue?vue&type=script&lang=js&"
import style0 from "./ClaimEditor.vue?vue&type=style&index=0&id=607c334e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607c334e",
  null
  
)

export default component.exports